<template>
  <div :style="boxWrapStyleObj" style="position: relative;">
    <div class="header-title-area" ref="statisTitle">
      <div class="area-title">
        <img src="../../../assets/images/nanjindataboard/right-row.png" />
        <p class="title-text">教学活动分析</p>
      </div>
      <img
        src="../../../assets/images/nanjindataboard/bottom-bg.png"
        style="float: left"
      />
    </div>
    <div class="content" :style="contentStyleObj">
      <!--图例-->
      <div class="echart-legend">
        <div class="legend-item">
          <p
            class="legend-item-color"
            :style="
              legendIndex == '课前'
                ? { background: '#0368E3' }
                : { background: '#A2A2A2' }
            "
          ></p>
          <p class="legend-item-text">课前</p>
        </div>
        <div class="legend-item">
          <p
            class="legend-item-color"
            :style="
              legendIndex == '课中'
                ? { background: '#F36D81' }
                : { background: '#A2A2A2' }
            "
          ></p>
          <p class="legend-item-text">课中</p>
        </div>
        <div class="legend-item">
          <p
            class="legend-item-color"
            :style="
              legendIndex == '课后'
                ? { background: '#7672ED' }
                : { background: '#A2A2A2' }
            "
          ></p>
          <p class="legend-item-text">课后</p>
        </div>
      </div>
      <div style="width: 100%; height: 100%" id="data_pie"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tea-active-analyse",
  data() {
    return {
      screenWidth: 0, //屏幕宽度
      boxWrapStyleObj: {
        height: "",
      },
      contentStyleObj: {
        height: "",
        marginTop: "0px",
      },
      legendIndex: "课前",
      data: [
        {
          pointList: [
            {
              displayName: "同步课件",
              count: "21526732",
            },
            {
              displayName: "网盘使用",
              count: "38667285",
            },
            {
              displayName: "资源中心",
              count: "71374956",
            },
            {
              displayName: "课堂活动",
              count: "45293402",
            },
          ],
          sceneType: 1,
          sceneName: "课前",
          count: 176862375,
        },
        {
          pointList: [
            {
              displayName: "板书",
              count: "96483795",
            },
            {
              displayName: "课本",
              count: "63827959",
            },
            {
              displayName: "课件",
              count: "12749746",
            },
            {
              displayName: "讲评",
              count: "17847532",
            },
            {
              displayName: "学科工具",
              count: "152563045",
            },
          ],
          sceneType: 2,
          sceneName: "课中",
          count: 343472077,
        },
        {
          pointList: [
            {
              displayName: "布置作业",
              count: "1118346",
            },
            {
              displayName: "检查作业",
              count: "35787072",
            },
            {
              displayName: "资源分享",
              count: "286498",
            },
            {
              displayName: "微课分享",
              count: "878362",
            },
          ],
          sceneType: 3,
          sceneName: "课后",
          count: 38070278,
        },
      ],
      pieData: [],
      defaultPointList: [],
      // smallPieColorArr: ["#4180FF", "#018AE6", "#03C4B0"],
      smallPieColorArr: ["#0368E3", "#F36D81", "#7672ED"],
      bigPieColorArr: [
        "#0368E3",
        "#329ED6",
        "#26C0E2",
        "#A0E3BA",
        "#FFDD84",
        "#F39C83",
        "#F36D81",
        "#E581AD",
        "#E2BFE9",
        "#7672ED",
      ],
    };
  },
  props: {
    name: String,
    schoolId: String,
    schoolName: String,
    form: String,
    paramTeaData: {
      type: Array,
      default: function () {
        return [];
      },
    },
    paramStuData: {
      type: Array,
      default: function () {
        return [];
      },
    },
    screenHeight: Number,
    titleHeight: Number,
  },
  watch: {
    screenHeight: "initBoxHeight",
    titleHeight: "initBoxHeight",
  },
  methods: {
    /**
     * 初始化box高度
     */
    initBoxHeight() {
      let winHeight = window.innerHeight;
      if (winHeight < 900) {
        winHeight = 938;
      }
      let boxWrapHeight = (winHeight - 128 - 10 - 30 - 20) / 3.5;
      let contentHeight =
        boxWrapHeight - this.$refs.statisTitle.offsetHeight - 10;
      this.boxWrapStyleObj.height = boxWrapHeight + "px";
      this.contentStyleObj.height = contentHeight + "px";
    },
    /**
     * 根据参数数组加载饼状图
     */
    copyParamData(list) {
      let _this = this;
      let _pieData = [];
      _this.defaultPointList = [];
      for (let i = 0; i < list.length; i++) {
        let pieItemObj = {};
        pieItemObj.name = list[i].sceneName;
        pieItemObj.value = list[i].count;
        pieItemObj.selected = false;
        pieItemObj.pointList = [];

        for (let j = 0; j < list[i].pointList.length; j++) {
          let pointObj = {};
          pointObj.name = list[i].pointList[j].displayName;
          pointObj.value = list[i].pointList[j].count;

          pieItemObj.pointList.push(pointObj);
          _this.defaultPointList.push(pointObj);
        }
        _pieData.push(pieItemObj);
      }
      return _pieData;
    },
    /**
     * 加载饼状图
     */
    initPie() {
      let _this = this;
      _this.pieData = _this.copyParamData(_this.data);
      // for(let i=0;i<_this.pieData.length;i++){
      //     _this.pieData[0].selected=true;
      // }
      let dataSourcePie = this.$echarts.init(
        document.getElementById("data_pie")
      );
      let bigPieColorList = [];
      let smallPieColorList = [];
      for (let i = 0; i < _this.pieData.length; i++) {
        smallPieColorList.push(_this.smallPieColorArr[i]);
      }
      for (let i = 0; i < _this.defaultPointList.length; i++) {
        bigPieColorList.push(_this.bigPieColorArr[i]);
      }

      let fontSize = 12;
      let smallPieRadius = "40%";
      let bigPieRadiusStart = "55%";
      let bigPieRadiusEnd = "70%";
      let smallMinAngle = 5;
      let bigMinAngle = 10;
      if (this.screenWidth <= 1680) {
        fontSize = 9;
        smallMinAngle = 10;
        bigMinAngle = 18;
      }
      if (this.screenWidth <= 1028) {
        fontSize = 8;
        smallMinAngle = 10;
        bigMinAngle = 18;
      }
      const option = {
        tooltip: {
          trigger: "item",
          formatter: "{b}: {c} ({d}%)",
        },
        series: [
          {
            name: "",
            type: "pie",
            minAngle: smallMinAngle, //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
            avoidLabelOverlap: true, //是否启用防止标签重叠策略
            selectedMode: "single",
            radius: [0, smallPieRadius],
            center: ["50%", "48%"], // 图的位置
            label: {
              normal: {
                position: "inner",
                fontSize: fontSize,
              },
            },
            labelLine: {
              normal: {
                show: false,
              },
            },
            data: _this.pieData,
            // color: ["#4180FF", "#018AE6", "#03C4B0"],
            color: ["#0368E3", "#F36D81", "#7672ED"],
          },
          {
            name: "",
            type: "pie",
            minAngle: bigMinAngle, //最小的扇区角度（0 ~ 360），用于防止某个值过小导致扇区太小影响交互
            avoidLabelOverlap: true, //是否启用防止标签重叠策略
            radius: [bigPieRadiusStart, bigPieRadiusEnd],
            center: ["50%", "48%"], // 图的位置
            label: {
              normal: {
                formatter: "{b}",
                fontSize: fontSize,
              },
            },
            labelLine: {
              normal: {
                length: 12,
                length2: 12,
              },
            },
            data: _this.defaultPointList,
            color: bigPieColorList,
          },
        ],
      };
      dataSourcePie.clear();
      let isNotMerge = true;
      option.series[0].data[0].selected = true;
      this.legendIndex = option.series[0].data[0].name;
      option.series[1].data = option.series[0].data[0].pointList;
      dataSourcePie.setOption(option, true);
      // 处理点击事件
      dataSourcePie.on("click", function (params) {
        if (params.seriesIndex == 0) {
          for (var i = 0; i < option.series[0].data.length; i++) {
            option.series[0].data[i].selected = false;
          }
          option.series[0].data[params.dataIndex].selected = true;
          _this.legendIndex = option.series[0].data[params.dataIndex].name;
          option.series[1].data =
            option.series[0].data[params.dataIndex].pointList;
          dataSourcePie.clear();
          dataSourcePie.setOption(option);
        }
      });
      window.addEventListener("resize", function () {
        dataSourcePie.resize();
      });
    },
  },
  mounted() {
    //获取屏幕宽度
    this.screenWidth =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    this.initBoxHeight();
    this.$nextTick(() => {
      this.initPie();
    });
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/databoard";

.header-title-area {
  margin-bottom: 30px;
  .area-title {
    display: flex;
    align-items: center;
    img {
      width: 13px;
      height: 20px;
      margin-right: 5px;
    }
    .title-text {
      font-size: 18px;
      font-weight: bold;
      color: #00bbff;
    }
  }
}
</style>
